module.exports = __webpack_public_path__ + "static/img/office_3.dd3d451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/office_3.png
// module id = /Hr/
// module chunks = 0